import { LayerProperty } from 'cadenza/map/layer-property';
import { logger } from 'cadenza/utils/logging';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class FeatureCreateGeometryBuffer extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('geometryBuffer.actionTitle')
    }, options));
    this.#map = options.map;
  }

  requiresObjectSelection () {
    return true;
  }

  executeSync () {
    const layerId = this._layer.get(LayerProperty.ID);
    showGeometryBufferDialog(this.#map, layerId);
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0;
  }

}

function showGeometryBufferDialog (map, layerId) {
  let dialog;
  return import(/* webpackChunkName: "geometry-buffer-dialog" */ '../geometry-buffer-dialog/geometry-buffer-dialog')
    .then(({ GeometryBufferDialog }) => {
      dialog = new GeometryBufferDialog(map, layerId);
      document.body.appendChild(dialog);
      return dialog.showModal();
    })
    .then(() => dialog.remove())
    .catch(error => {
      logger.error('Failed to import module geometry-buffer-dialog.', error);
    });
}
